import React from 'react'
import { List } from 'antd'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { getFirstSubstring } from 'src/core/helpers'
import styles from './ProjectDetailsInfo.module.scss'
import { CustomText, CustomLink } from 'src/components'
import { projectInfoSections } from './project-info.sections'

interface ProjectDetailsInfoProps { project: Project, isModalPreview: boolean }

const ProjectDetailsInfo: React.FC<ProjectDetailsInfoProps> = ({ project, isModalPreview }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  const addressLink = `${process.env.ALGORAND_EXPLORER}${project?.bc_address}`
  const blockchainAdress = `${getFirstSubstring(project?.bc_address, isMobile ? 10 : 30)}...`

  const texts = projectInfoSections(project, isModalPreview, addressLink, blockchainAdress, t)

  return <div className={styles.content}>
    <List
      dataSource={texts}
      renderItem={item => {
        if (!item.isVisible) return
        return (
          <List.Item>
            <React.Fragment>
              <CustomText label={item.label1 || '-'} />
              {item.isLink ? (
                <CustomLink
                  label={item.linkLabel || '-'}
                  link={String(item.label2) || '-'}
                  icon={null}
                  isSmallText
                  isStrong
                />
              ) : (
                <CustomText
                  label={item.label2 || '-'}
                  strong
                />
              )}
            </React.Fragment>
          </List.Item>
        )
      }}
    />
  </div>
}

export default ProjectDetailsInfo
